import { render } from "./TopRightMargin.vue?vue&type=template&id=7985fbec&scoped=true"
import script from "./TopRightMargin.vue?vue&type=script&lang=js"
export * from "./TopRightMargin.vue?vue&type=script&lang=js"

import "./TopRightMargin.vue?vue&type=style&index=0&id=7985fbec&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7985fbec"]])

export default __exports__